/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import Search from "./Search.container";

export default Search;
